import { ShortTermParkingWizard } from 'hooks/useShortTermParkingWizard';
import * as React from 'react';

const noop = () => undefined;

const ParkingContext = React.createContext<ShortTermParkingWizard>({
  setSelectedEvCharger: noop,
  setSelectedParkzonePmcUnion: noop,
  isOngoingParking: false,
  isLoadingParkZoneDetails: false,
  hasEVCharge: false,
});

export default ParkingContext;
